import styled, { css } from 'styled-components';
import { getColor } from 'core/utils/Styles';
import { Button as Btn } from 'core/components/Login/LoginWorkflow/SignIn/signInStyles';
import Inpt from 'core/components/Form/Input';
import { desktop } from 'core/components/Form/formStyles';

export const Form = styled.form`
	position: relative;
	z-index: 1;
	max-width: 320px;
	margin: 0 auto;
	text-align: center;

	${desktop`
		max-width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	`}
`;

export const Header = styled.div`
	${desktop`
		margin-right: auto;
		text-align: left;
		max-width: 300px;
		flex-basis: 300px;
	`}
`;

export const GroupInput = styled.div`
	${desktop`
		margin-left: 7%;
		display: flex;
		flex: 1;
	`}
`;

export const Title = styled.h3`
	margin: 0;
	margin-bottom: 7px;
	font-size: 25px;
	font-weight: 700;
	line-height: 0.96;
	letter-spacing: 0.2px;
	color: ${getColor('lavender')};
`;

export const Subtitle = styled.h6`
	margin: 0;
	margin-bottom: 7px;
	font-size: 14px;
	line-height: 1.57;
	letter-spacing: 0.2px;
	color: ${getColor('lavender')};
`;

export const Button = styled(Btn)`
	margin-top: 24px;
	width: 100%;
	font-size: 16px;
	padding-top: 15px;
	padding-bottom: 15px;
	height: 48px;
	font-weight: 500;
	box-shadow: 0 2px 4px 0 rgba(74, 74, 74, 0.3);

	${desktop`
		margin-top: 0;
		max-width: 170px;
		flex-basis: 170px;
		height: 54px;
	`}
`;

export const InputWrapper = styled.div`
	${desktop`
		margin-right: 16px;
		margin-top: 0;
		max-width: 300px;
		flex-basis: 300px;
	`}
`;

export const Input = styled(Inpt)`
	margin-top: 24px;

	${desktop`
		margin-top: 0;
	`}
`;
